function ChartBuilder (el) {
    var apiUrl = '/api/v1/chart-data';
    var self = this;
    this.el = el;
    this.cid = el.getAttribute('data-cid');
    this.pid = el.getAttribute('data-pid');
    this.name = el.getAttribute('data-chart-name');
    this.type = el.getAttribute('data-chart-type');
    this.horizontalChart = el.getAttribute('data-horizontal-chart') == 'true' ? true : false;
    this.fieldName = el.getAttribute('data-field-name');
    this.unitType = el.getAttribute('data-unit-type');
    this.donutSolid = el.getAttribute('data-donut-solid') == 'true' ? true : false;
    this.extraOptionsId = el.getAttribute('data-extra-options-id');
    this.data = {};
    this.chart = {};
    
    function getOptions() {
        if (self.type == 'pie') {
            return {
                height: 307,
                donut: false,
                startAngle: 360,
                showLabel: false,
                plugins: [
                    /*
                    Chartist.plugins.ctPieLabels({
                        labelInterpolationFnc: function (value, totalValueSum) {
                            return Math.round((value / totalValueSum) * 100) + '%';
                        }
                    }),
                    */
                    Chartist.plugins.tooltip({
                        tooltipFnc: function(meta) {
                            return meta;
                        }
                    }),
                    Chartist.plugins.legend({
                        clickable: false,
                        position: jq(self.el).parent().find('.ct-legend-wrapper')[0] ? jq(self.el).parent().find('.ct-legend-wrapper')[0] : 'bottom'
                    })
                ]
            };
        }else {
            return {
                height: 340,
                fullWidth: true,
                chartPadding: {
                    top: 20,
                    right: 0,
                    bottom: 10,
                    left: -15
                },
                axisX: {
                    showGrid: false,
                    showLabel: true
                },
                axisY: {
                    showGrid: true,
                    showLabel: false,
                    offset: 30,
                    scaleMinSpace: 30
                },
                seriesBarDistance: 20,
                distributeSeries: true,
                plugins: [
                    Chartist.plugins.ctBarLabels({
                        labelInterpolationFnc: function (text) {
                            if (self.unitType == 'none') {
                                return parseFloat(text).toLocaleString();
                            } else {
                                return '$' + parseFloat(text).toLocaleString();
                            }
                        },
                        position: {
                            y: function (data) {
                                return data.y2 - 10;
                            },
                            x: function (data) {
                                if (self.horizontalChart === true) {
                                    return data.x2 - 10;
                                } else {
                                    return data.x1;
                                }
                            }
                        }
                    }),
                    // Chartist.plugins.legend({
                    //     clickable: false,
                    //     position: jq(self.el).parent().find('.ct-legend-wrapper')[0] ? jq(self.el).parent().find('.ct-legend-wrapper')[0] : 'bottom'
                    // })
                ]
            }
        }
    }
    
    
    function registerHandlers ()
    {
        self.chart.on('draw', function (event) {
            // X-axis label centering fix for IE11
            if (event.type === 'label' && event.axis.units.pos === 'x') {
                if (!self.chart.supportsForeignObject) {
                    //console.log(event);
                    event.element.attr({
                        x: event.x + (event.width / 2) - 15,
                        'text-anchor': 'middle'
                    });
                }
            }
        });
        jq('.nav a').on('shown.bs.tab', function (e) {
            console.log('tab shown');
            var target = jq(this).attr('href');
            
            if (jq(target).find(self.el).length > 0) {
                console.log('update chart');
                self.chart.update();
            }
        });
    }
    
    function getChartData () {
        return new Promise(function (resolve, reject) {
            var url = new URL(window.location.protocol + '//' + window.location.hostname + apiUrl),
            params = {
                cid: self.cid,
                pid: self.pid,
                chart_name: self.name,
                field_name: self.fieldName
            };
            Object.keys(params).forEach(function (key) {
                url.searchParams.append(key, params[key]);
            });
            //console.log(url);
            fetch(url).then(function (response) {
                return response.json();
            }).then(function (results) {
                if (self.type == 'bar') {
                    // Chartist.Bar requires data.series to be a multi-dimensional array
                    self.data.series = results.series;
                    self.data.labels = results.labels;
                } else {
                    // Converts strings that may have quantifiers like M, B, K, etc. to numbers
                    self.data.series = results.series;
                    // Holds full value strings to use in the legend
                    self.data.labelValues = results.series;
                    
                    if (self.unitType == 'percentage') {
                        self.data.labels = results.labels.map(function (el, i) {
                            //console.log(self.data.series[i]);
                            return self.data.series[i].meta;
                        });
                    }else {
                        self.data.labels = results.labels.map(function (el, i) {
                            //return '<span class="currency">$' + self.data.labelValues[i] + '</span> ' + el;
                            return el;
                        });
                    }
                }
                resolve();
            });
        });
    }
    getChartData().then(function () {
      // We allow for entirely custom options to be passed via a JSON script.
      var customOpts = {};  
      if (document.getElementById(self.extraOptionsId)) {
          customOpts = JSON.parse(document.getElementById(self.extraOptionsId).innerHTML);
      }
      var opts = Object.assign({}, getOptions(), customOpts);
      
      if (self.type == 'pie') {
          self.chart = new Chartist.Pie(self.el, self.data, opts);
      }else {
          self.chart = new Chartist.Bar(self.el, self.data, opts);
      }
      registerHandlers();
    });
}

var charts = document.querySelectorAll('.chartist-chart')
if (charts.length) {
    charts.forEach(function (el) {
        new ChartBuilder(el);
    });
}